/* eslint-disable template-curly-spacing */
import utils from '@/utils/common'

const { getStorage } = utils

export const fetchImagesFromMarkdown = text => {
  const imageUrls = []
  const imageRegex = /!\[Image\]\(([^)]+)\)/g
  let match
  // eslint-disable-next-line no-cond-assign
  while ((match = imageRegex.exec(text)) !== null) {
    let src = match[1]
    if (!src.startsWith('http')) {
      src = getStorage(src.split('storage')[1])
    }
    imageUrls.push(src)
  }
  return imageUrls
}

const parseMarkdown = text => {
  if (!text) return ''

  let html = text

  // Parse mentions BEFORE HTML escaping - format: @[Name](uuid)
  html = html.replace(/@\[([^\]]+)\]\(([^)]+)\)/g, '___MENTION_START___$1___MENTION_MID___$2___MENTION_END___')

  // Escape HTML
  html = html
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // Code blocks with language
  html = html.replace(/```(\w+)?\n([\s\S]*?)```/g, (match, lang, code) => {
    const language = lang || 'text'
    return `<pre><code class="language-${language}">${code.trim()}</code></pre>`
  })

  // Inline code
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>')

  // Horizontal rules (must be before headers to avoid conflicts)
  html = html.replace(/^(---|\*\*\*|___)$/gim, '<hr>')

  // Headers
  html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>')
  html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>')
  html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>')

  // Images - look for [!Image](url)
  html = html.replace(/!\[Image\]\(([^)]+)\)/g, (_, src) => {
    const imgSrc = src.includes('storage') ? getStorage(src.split('storage')[1]) : src
    return `<img src="${imgSrc}" alt="Image" width="100%" />`
  })

  // Videos - look for ![Video](url)
  html = html.replace(/!\[Video\]\(([^)]+)\)/g, (_, src) => {
    const videoSrc = src.includes('storage') ? getStorage(src.split('storage')[1]) : src
    return `<video src="${videoSrc}" controls width="100%" style="max-height: 500px;"></video>`
  })

  // Files - look for ![File](url)
  html = html.replace(/!\[File\]\(([^)]+)\)/g, (match, src) => {
    const fileSrc = src.includes('storage') ? getStorage(src.split('storage')[1]) : src
    return `<a href="${fileSrc}" target="_blank" download>Download File</a>`
  })

  // Bold
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>')

  // Italic
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>')
  html = html.replace(/_(.+?)_/g, '<em>$1</em>')

  // Links
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')

  // Convert mention placeholders back to HTML
  html = html.replace(/___MENTION_START___([^_]+)___MENTION_MID___([^_]+)___MENTION_END___/g, '<span class="mention" data-user-id="$2">@$1</span>')

  // Unordered lists
  html = html.replace(/^\* (.+)$/gim, '<li>$1</li>')
  html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>')

  // Ordered lists
  html = html.replace(/^\d+\. (.+)$/gim, '<li>$1</li>')

  // Blockquotes
  html = html.replace(/^&gt; (.+)$/gim, '<blockquote>$1</blockquote>')

  // Line breaks
  html = html.replace(/\n/g, '<br>')

  return html
}

export const getVideoEmbed = url => {
  // YouTube
  const ytMatch = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/,
  )
  if (ytMatch) {
    const id = ytMatch[1]
    return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${id}" frameborder="0" allowfullscreen></iframe>`
  }

  // Vimeo
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/)
  if (vimeoMatch) {
    const id = vimeoMatch[1]
    return `<iframe src="https://player.vimeo.com/video/${id}" width="640" height="360" frameborder="0" allowfullscreen></iframe>`
  }

  // Loom
  const loomMatch = url.match(/loom\.com\/share\/([A-Za-z0-9]+)/)
  if (loomMatch) {
    const id = loomMatch[1]
    return `<iframe src="https://www.loom.com/embed/${id}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`
  }

  return null
}

export const processMentionContentForEditor = (content, members = []) => {
  let processedContent = content
  if (members.length) {
    members.forEach(member => {
      const regex = new RegExp(`@${member.uuid}`, 'g')
      const replacement = `@${member.uuid} (${member.name})`
      processedContent = processedContent?.replace(regex, replacement)
    })
  }

  return processedContent
}

export const processMentionContent = (content, members = []) => {
  let processedContent = content
  members.forEach(member => {
    const regex = new RegExp(`@${member.uuid}(\\s*\\([^)]+\\))?`, 'g')
    const replacement = `<span class="mention" data-user-id="${member.uuid}">@${member.name}</span>`
    processedContent = processedContent?.replace(regex, replacement)
  })

  return processedContent
}

export const removeNameFromMentions = content => content.replace(/@([a-f0-9-]+)\s*\([^)]+\)/g, '@$1')

export default parseMarkdown
